import React from 'react'
import { twoDigitMoney } from 'helpers/utils'

function MoneyCell({ value }) {
  return (
    <td className="align-middle text-muted fw-light">
      {twoDigitMoney(value)}
    </td>
  )
}

export default MoneyCell